// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_as-4";
export var collapsed = "_as-1";
export var headerBar = "_as-0";
export var leftHeaderContent = "_as-3";
export var subjectContainer = "_as-2";